import {
    SOCIETY_GET_NOTICES_LIST,
    SOCIETY_GET_NOTICE_BOARD,
    SOCIETY_GET_NOTICE_DETAILS,
    SOCIETY_CREATE_NOTICE,
    SOCIETY_UPDATE_NOTICE,
    SOCIETY_DELETE_NOTICE,
    SOCIETY_PUBLISH_NOTICE,
    SOCIETY_ARCHIVE_NOTICE,
    SOCIETY_RESEND_NOTICE,
    SOCIETY_GET_NOTICE_COMMENTS,
    SOCIETY_ADD_NOTICE_COMMENT,
    SOCIETY_DELETE_NOTICE_COMMENT,
    SOCIETY_UPLOAD_NOTICE_ATTACHMENTS,
    SOCIETY_DELETE_NOTICE_ATTACHMENT,
    SOCIETY_ACKNOWLEDGE_NOTICE,
    SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS,
    SOCIETY_GET_NOTICE_ENUMS,
    SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS,
    SOCIETY_GET_NOTICE_STATS,
} from '../../index.types';

export const getNoticesList = (data) => ({ type: SOCIETY_GET_NOTICES_LIST, data });
export const getNoticeBoard = (data) => ({ type: SOCIETY_GET_NOTICE_BOARD, data });
export const getNoticeDetails = (data) => ({ type: SOCIETY_GET_NOTICE_DETAILS, data });
export const createNotice = (data) => ({ type: SOCIETY_CREATE_NOTICE, data });
export const updateNotice = (data) => ({ type: SOCIETY_UPDATE_NOTICE, data });
export const deleteNotice = (data) => ({ type: SOCIETY_DELETE_NOTICE, data });
export const publishNotice = (data) => ({ type: SOCIETY_PUBLISH_NOTICE, data });
export const archiveNotice = (data) => ({ type: SOCIETY_ARCHIVE_NOTICE, data });
export const resendNotice = (data) => ({ type: SOCIETY_RESEND_NOTICE, data });
export const getNoticeComments = (data) => ({ type: SOCIETY_GET_NOTICE_COMMENTS, data });
export const addNoticeComment = (data) => ({ type: SOCIETY_ADD_NOTICE_COMMENT, data });
export const deleteNoticeComment = (data) => ({ type: SOCIETY_DELETE_NOTICE_COMMENT, data });
export const uploadNoticeAttachments = (data) => ({ type: SOCIETY_UPLOAD_NOTICE_ATTACHMENTS, data });
export const deleteNoticeAttachment = (data) => ({ type: SOCIETY_DELETE_NOTICE_ATTACHMENT, data });
export const acknowledgeNotice = (data) => ({ type: SOCIETY_ACKNOWLEDGE_NOTICE, data });
export const getNoticeAcknowledgements = (data) => ({ type: SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS, data });
export const getNoticeEnums = (data) => ({ type: SOCIETY_GET_NOTICE_ENUMS, data });
export const getNoticeAudienceOptions = (data) => ({ type: SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS, data });
export const getNoticeStats = (data) => ({ type: SOCIETY_GET_NOTICE_STATS, data });
